import { Component, Input } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { InvestmentListItem } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-deposit-investment-button',
  templateUrl: './deposit-investment-button.component.html',
  styleUrls: ['./deposit-investment-button.component.scss'],
  standalone: false
})
export class DepositInvestmentButtonComponent {
  @Input() public investmentData!: InvestmentListItem;

  public constructor(
    private modalService: ModalService,
  ) { }

  public openMoneyModal(): void {
    this.modalService.openMoneyDepositModal(this.investmentData.id);
  }
}
